// extracted by mini-css-extract-plugin
export var body = "_ko-0";
export var sectionHeader = "_ko-4";
export var shortcutColumns = "_ko-2";
export var shortcutList = "_ko-1";
export var shortcutSection = "_ko-3";